/*
  Softech Store - "Total for N" under the product price (Najam 4 Oct 2026, qty_total).

  Total = selected variant price x quantity; when the variant has a compare-at price above
  its price, the compare-at total is shown struck through before it. The line is hidden at
  quantity 1 (the price above is already the total) and when the quantity field is not on
  the page or not visible, and on band products, whose band box already shows a total.
  Updates on typing, on the - / + buttons, on variant change and
  after the theme redraws the product.

  Pure functions are exported for node tests (module.exports); the DOM part runs only in a browser.
*/
(function (root) {
  'use strict';

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    function fmt(n, dec, th, ds) {
      var neg = n < 0; n = Math.abs(n);
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return (neg ? '-' : '') + parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  // -> null (hide) or {qty, total, compare} as formatted strings
  function totals(variant, qty, format) {
    if (!variant || !isFinite(qty) || qty < 2) return null;
    var out = { qty: qty, total: formatMoney(variant.price * qty, format), compare: null };
    if (variant.compare_at && variant.compare_at > variant.price) out.compare = formatMoney(variant.compare_at * qty, format);
    return out;
  }

  var api = { formatMoney: formatMoney, totals: totals };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SoftechQtyTotal = api;
  if (typeof document === 'undefined') return;

  // ------------------------------------------------------------------ DOM part
  function data(sid) {
    var s = document.getElementById('SoftechQtyTotalData-' + sid);
    if (!s) return null;
    if (s._sqt) return s._sqt;
    try { s._sqt = JSON.parse(s.textContent); } catch (e) { return null; }
    return s._sqt;
  }

  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  function render(line) {
    var sid = line.getAttribute('data-section');
    var d = data(sid);
    var input = document.getElementById('Quantity-' + sid);
    var form = document.getElementById('product-form-' + sid);
    var idIn = form && form.querySelector('input[name="id"]');
    var t = null;
    // Band products (softech-user-bands.js) already show a total in their band box: no second total.
    var bandBox = document.getElementById('SoftechBand-' + sid);
    if (d && input && idIn && visible(input) && !bandBox) {
      var vid = String(idIn.value), variant = null;
      for (var i = 0; i < d.variants.length; i++) if (String(d.variants[i].id) === vid) { variant = d.variants[i]; break; }
      t = totals(variant, parseInt(input.value, 10), d.money_format);
    }
    if (!t) { if (!line.hidden) { line.hidden = true; line.textContent = ''; } return; }
    var html = '<span class="sqt-label">Total for ' + t.qty + ':</span> ' +
      (t.compare ? '<s class="sqt-compare"><span class="visually-hidden">Regular price </span>' + t.compare + '</s> ' : '') +
      '<span class="sqt-amount">' + t.total + '</span>';
    if (line.innerHTML !== html) line.innerHTML = html;
    line.hidden = false;
  }

  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.sqt-line[data-section]'), render);
  }

  var pending = null;
  function schedule() {
    // now, and again once the theme / band script has finished resetting the quantity
    renderAll();
    clearTimeout(pending);
    pending = setTimeout(renderAll, 150);
  }

  function boot() {
    if (root.__sqtBooted) { renderAll(); return; }
    root.__sqtBooted = true;
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') schedule(); });
    document.addEventListener('change', schedule);
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.quantity__button')) schedule(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, schedule);
      if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, schedule);
    }
    renderAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})(typeof window !== 'undefined' ? window : this);
